<template>
    <div>
        <consultoria
            :consultoria="consultoria"
            v-show="mostrarConsultoria"
            :solicitacao="true"
            :services="obterServices()"
            @obterConsultoriaAtualizada="obterConsultoriaAtualizada()"
        >
            <template slot="footer">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </consultoria>
    </div>
</template>

<script>
import ConsultoriasServicos from './ConsultoriasServicos'
import Consultoria from '../../componentes/consultorias/Consultoria'

export default {
    data() {
        return {
            consultoria: {}
        }
    },

    methods: {
        obterServices() {
            return ConsultoriasServicos
        },

        obterConsultoria() {
            this.$store.dispatch('addRequest')
            ConsultoriasServicos.obterSolicitacaoPorId(
                this.$route.params.consultoriaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.consultoria = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter solicitação!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterConsultoriaAtualizada() {
            this.obterConsultoria()
            this.$store.dispatch('setRecarregar', true)
        }
    },

    computed: {
        mostrarConsultoria() {
            return (
                this.$route.name ==
                'AppSebrae_Consultorias_Fornecedor_Solicitacoes_Detalhar'
            )
        }
    },

    mounted() {
        this.obterConsultoria()
    },

    components: {
        Consultoria
    }
}
</script>
